import { TeamForm } from "../teams/TeamForm";
import { useState } from "react";
import { Button } from "@repo/ui/components/Base/Button";
import { PlusCircleIcon } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { useTeamList } from "@/hooks/queryHooks/teamHooks";

type CreateTeamsStepProps = {
  tenantId: string;
};
export const CreateTeamsStep = ({ tenantId }: CreateTeamsStepProps) => {
  const { data: teams } = useTeamList(tenantId);
  const [addTeamVisible, setAddTeamVisible] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const handleContinue = () => {
    setSearchParams((searchParams) => {
      searchParams.set(
        "stepId",
        `${parseInt(searchParams.get("stepId") ?? "0") + 1}`
      );
      return searchParams;
    });
  };
  return (
    <>
      <h1 className="bg-tertiary rounded-lg text-xl text-white p-2">{`Step ${searchParams.get(
        "stepId"
      )}`}</h1>
      <h2 className="text-xl">Setup your teams</h2>
      <p>
        The next step is to set up your teams. Each team is a group of
        individuals that coincide with your departments, committees, task
        forces, commissions, and boards.
      </p>
      <p>You will have an opportunity to modify the teams later.</p>
      {teams && teams.length > 0 && (
        <div>
          <h3 className="text-lg">Current Teams:</h3>
          <ul>
            {teams
              ?.sort((a, b) => (a.name > b.name ? 1 : -1))
              .map((team) => (
                <li className="pl-4" key={team.id}>
                  {team.name}
                </li>
              ))}
          </ul>
        </div>
      )}
      {teams?.length === 0 && (
        <div className=" border-2 p-2 rounded-lg shadow-xl">
          <h1 className="text-lg bg-primary p-2 text-primary-foreground rounded-md">
            Create new team
          </h1>
          <TeamForm
            tenantId={tenantId}
            handleComplete={() => console.log("Created Team")}
            completeButtonText="Add Team"
          />
        </div>
      )}

      {teams && teams.length > 0 && addTeamVisible && (
        <div className=" border-2 p-2 rounded-lg shadow-xl">
          <h1 className="text-lg bg-primary p-2 text-primary-foreground rounded-md">
            Create new team
          </h1>
          <TeamForm
            tenantId={tenantId}
            handleComplete={() => setAddTeamVisible(false)}
            handleCancel={() => setAddTeamVisible(false)}
            cancelButtonText="Cancel"
            completeButtonText="Add Team"
          />
        </div>
      )}
      {teams && teams.length > 0 && !addTeamVisible && (
        <div className="flex flex-row justify-between w-full">
          <Button variant="secondary" onClick={() => setAddTeamVisible(true)}>
            <PlusCircleIcon className="pr-4" size={40} /> Add Another Team
          </Button>

          <Button onClick={() => handleContinue()}>Continue</Button>
        </div>
      )}
    </>
  );
};
